import { render, staticRenderFns } from "./PersonHeader.vue?vue&type=template&id=f0dbdb0c&scoped=true"
import script from "./PersonHeader.vue?vue&type=script&lang=js"
export * from "./PersonHeader.vue?vue&type=script&lang=js"
import style0 from "./PersonHeader.vue?vue&type=style&index=0&id=f0dbdb0c&prod&lang=scss&scoped=true"
import style1 from "./PersonHeader.vue?vue&type=style&index=1&id=f0dbdb0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0dbdb0c",
  null
  
)

export default component.exports